/*
 * Galpón — Reveal on scroll (sistema único: home + colección + lo que venga)
 *
 * Técnica como Horizon 4: el estado OCULTO vive en CSS (colgado de los atributos
 * data-reveal*, presentes en el HTML antes del primer paint, bajo html.gd-js).
 * Este JS NO agrega el estado oculto → CERO flash. Solo agrega .gd-reveal--in
 * cuando el elemento entra en viewport, una sola vez.
 *
 * Modos:
 *   <div data-reveal>                  // el bloque entero aparece al entrar
 *   <div data-reveal data-reveal-stagger>  // + hijos directos escalonados (grupos chicos, home)
 *   <div data-reveal-each>             // cada hijo aparece cuando ÉL entra (grillas largas, colección)
 *
 * Respeta prefers-reduced-motion (el CSS muestra todo; igual marcamos --in por si acaso).
 */
(function () {
  const init = () => {
    const blocks = document.querySelectorAll('[data-reveal]');
    const grids = document.querySelectorAll('[data-reveal-each]');
    if (!blocks.length && !grids.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      blocks.forEach((el) => el.classList.add('gd-reveal--in'));
      grids.forEach((g) => [...g.children].forEach((c) => c.classList.add('gd-reveal--in')));
      return;
    }

    // Bloques: el contenedor entra → revela (stagger lo maneja el CSS + --reveal-delay en hijos)
    const ioBlock = new IntersectionObserver((entries, obs) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        if (el.hasAttribute('data-reveal-stagger')) {
          [...el.children].forEach((k, i) => k.style.setProperty('--reveal-delay', (i * 90) + 'ms'));
        }
        el.classList.add('gd-reveal--in');
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    blocks.forEach((el) => ioBlock.observe(el));

    // Grillas: cada hijo se revela cuando ÉL entra, con stagger por fila (los que
    // entran en el mismo tick se ordenan por posición y se escalonan suave).
    const ioEach = new IntersectionObserver((entries, obs) => {
      const incoming = entries.filter((e) => e.isIntersecting).sort((a, b) => {
        const ra = a.target.getBoundingClientRect(), rb = b.target.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      incoming.forEach((en, i) => {
        en.target.style.setProperty('--reveal-delay', (i * 70) + 'ms');
        en.target.classList.add('gd-reveal--in');
        obs.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    const observeChild = (child) => {
      if (child.nodeType !== 1 || child.classList.contains('gd-reveal--in')) return;
      ioEach.observe(child);
    };
    grids.forEach((grid) => {
      [...grid.children].forEach(observeChild);
      // cards que llegan por scroll infinito de Horizon → engancharlas también
      new MutationObserver((muts) => {
        muts.forEach((m) => m.addedNodes.forEach(observeChild));
      }).observe(grid, { childList: true });
    });
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
